import { MAP_KEY } from './map-key.token';

export const provideMap = (key?: string) => ({
    provide: MAP_KEY,
    useValue: key,
});
